import APIClient from '@/shared/http/clients/api'

const resourceName = 'parametros/wpp'
const APICore = process.env.APIBaseURLCore

const GetParams = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const UpdateParams = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/`, data, config)

const ParametroWhatsappRepository = {
  GetParams,
  Create,
  UpdateParams
}

export default ParametroWhatsappRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/parametroDisparoWhatsapp.js